<template>
  <div
    class="position-relative d-flex flex-column"
    :class="active === 0 ? 'bg-gray' : 'bg-face-detect cs-steps'"
  >
    <div class="step-container">
      <template v-for="(step, index) in steps" :key="index">
        <div
          class="step"
          :class="{ active: active === index }"
          @click="setStep(index)"
        >
          <p class="step-number">{{ index + 1 }}</p>
          <p class="step-name">{{ $t(step) }}</p>
        </div>
        <!-- Thêm đường line giữa các bước (Không hiển thị sau bước cuối cùng) -->
        <div
          v-if="index < steps.length - 1"
          class="step-line"
          :class="{ active: active > index }"
        ></div>
      </template>
    </div>
    <!-- Start Step 1 -->
    <div
      v-if="active === 0"
      class="d-flex flex-column flex-grow-1 overflow-hidden"
    >
      <div class="d-flex justify-content-center">
        <p class="text-white opacity-75 font-size-12">
          {{ $t("esim_place_card_correctly") }}
        </p>
      </div>

      <!-- Bọc toàn bộ phần dưới trong 1 div flex-grow-1 để chiếm phần còn lại -->
      <div class="d-flex flex-column flex-grow-1 overflow-hidden">
        <!-- Camera chiếm phần lớn chiều cao -->
        <div
          class="d-flex justify-content-center flex-grow-1 cs-camera w-100 align-items-center"
        >
          <Camera
            v-if="!imgCCCD"
            ref="camera"
            @photoCaptured="handlePhotoCaptured"
          />
        </div>

        <GuideCapture :type="0" />

        <div class="d-flex justify-content-center">
          <button
            v-if="!imgCCCD"
            @click="capturePhoto"
            class="btn-capture-photo my-4"
          ></button>
        </div>
      </div>
    </div>
    <div v-if="imgCCCD && active === 0" class="capture-screen">
      <CaptureScreen
        :image="imgCCCD"
        @retake="retakePhoto"
        @continue="continueProcess"
        :activeStep-="active"
      />
    </div>
    <!-- End Step 1 -->

    <!-- Start Step 2 -->
    <div v-if="active === 1">
      <FaceAuth ref="faceIdComponent" @base64Image="handleChildBase64Image" />
    </div>
    <!-- End Step 2 -->
  </div>
</template>

<script>
import { Button, Image } from "vant";
import Camera from "@/components/ui/Camera/Camera.vue";
import CaptureScreen from "@/components/ui/Camera/CaptureScreen.vue";
import GuideCapture from "@/components/ui/Camera/GuideCapture.vue";
import FaceAuth from "@/components/ui/Camera/FaceAuth.vue";
import { mapState } from "vuex";
import { CONSTANTS } from "@/helpers/constants";
import {IDCARD_IMAGE, PORTRAIT_IMAGE} from "@/ultis/fakeImage";

export default {
  name: "Id Card",
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    Camera,
    CaptureScreen,
    GuideCapture,
    FaceAuth,
  },
  data() {
    return {
      capturedImage: "",
      active: 0,
      steps: ["esim_front_side", "esim_face_detect"],
      itemCCCD: null,
      itemPassport: null,
      itemFaceId: null,
      imgCCCD: null,
      imgFaceId: null,
      isShowCardInfo: false,
    };
  },
  created() {
    this.itemCCCD = this.itemCCCDStore ? this.itemCCCDStore : null;
    this.imgCCCD = this.imgCCCDStore ? this.imgCCCDStore : null;

    this.itemFaceId = this.itemFaceIdStore ? this.itemFaceIdStore : null;
    this.imgFaceId = this.imgFaceIdStore ? this.imgFaceIdStore : null;

     
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("esimBuyStore", ["orderDetail"]),
    ...mapState("headerStore", ["title"]),
    ...mapState("verificationInfoStore", ["itemCCCDStore", "imgCCCDStore"]),
    ...mapState("verificationInfoStore", ["itemFaceIdStore", "imgFaceIdStore"]),
  },
  mounted() {
    this.changeTitle(this.$t("esim_register_info"));
     
  },
  watch: {
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "esim_register_info");
      },
      immediate: false,
    },
    "$route.hash": {
      handler: function (id_step) {
        console.log("id_step");
        if (id_step) {
          if (id_step == "#front-side") {
            this.active = 0;
            this.imgCCCD = null;
          } else if (id_step == "#face-detect") {
            this.active = 1;
            this.$refs.faceIdComponent?.enableWebcam();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => {});
    },
    setStep(index) {
      this.active = index;
    },
    handleNextSteps() {
      if (this.active < this.steps.length - 1) this.active++;
    },
    handlePreviousSteps() {
      if (this.active > 0) this.active--;
    },
    capturePhoto() {
      this.$refs.camera.capturePhoto();
    },
    async handlePhotoCaptured(image) {
      if(process.env.VUE_APP_ENV == "dev") { 
        console.log("handlePhotoCaptured:", image);
        const result = {
            "errorCode": 0,
            "message": "Success",
            "errorDecription": "Success",
            "confidence": {
                "dob": "07/10/1995",
                "expiredDate": "2035/03/14",
                "id": "2015/03/15",
                "issuedDate": "2015/03/15",
                "name": "Fake Data",
                "province": "PNP",
                "sex": "M"
            },
            "idCardInfo": {
                "enDob": "07/10/1995",
                "enExpiredDate": "01.01.2030",
                "enIssuedDate": "01.01.2020",
                "enProvince": "House 20, Street 614, Village 13, Sangkat Boeung Kak II, Khan Toul Kork, Phnom Penh",
                "enSex": "Female",
                "idNumber": "090505246",
                "isFraud": "false",
                "khDob": "០៩.០៩.១៩៨២",
                "khExpiredDate": "១០.០១.២០៣០",
                "khIssuedDate": "១០.០១.២០២០",
                "khProvince": "ផ្ទះ២០ ផ្លូវ៦១៤ ភូមិ១៣ សង្កាត់បឹងកក់ទី ២ ខណ្ឌទួលគោក ភ្នំពេញ",
                "khSex": "ស្រី",
                "name": "VA LIDA"
            },
            "partner": "MASCOM",
            "transid": "17779060359731"
        };

        this.itemCCCD = result;
        this.imgCCCD = IDCARD_IMAGE;
        this.$store.dispatch(
          "verificationInfoStore/setItemCCCD",
          result
        );
        this.$store.dispatch("verificationInfoStore/setImgCCCD", this.imgCCCD);

        
      return;
      }

      if (this.defaultParam) {
        let params = this.stateAsObject(this.defaultParam);
        if (this.orderDetail) {
          params.isdn = this.orderDetail.esimIsdn;
        }
        if (image) {
          params.image = image.replace(/^data:image\/\w+;base64,/, "");
        } 
        if (this.profile) {
          let tempPhone = this.profile.phone.replace(/\D/g, "");
          params.msisdn = tempPhone;
          params.partnerAccount = this.profile.id;
        }

        if (!this.orderDetail) return;

        this.$store.dispatch("loadingStore/showLoading", { status: true });

        // CCCD
        this.itemCCCD = null;
        await this.$store
          .dispatch("esimMetfoneStore/idCardReaderV2EsimABA", params)
          .then((res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                this.itemCCCD = result;
                this.imgCCCD = image;
                this.$store.dispatch(
                  "verificationInfoStore/setItemCCCD",
                  result
                );
                this.$store.dispatch("verificationInfoStore/setImgCCCD", image);
              } else {
                this.$notify({
                  code: result.errorCode,
                  message: result.errorDecription || result.message,
                });
              }
            }
          });
        this.$store.dispatch("loadingStore/showLoading", { status: false });
      }
    },
    retakePhoto() {
      this.imgCCCD = null;
    },
    continueProcess() {
      this.active = 1;
    },

    async handleChildBase64Image(base64) {
      if (process.env.VUE_APP_ENV == "dev") { 
        this.imgFaceId = PORTRAIT_IMAGE;
        const result  = {
            "errorCode": 0,
            "message": "Success",
            "errorDecription": "Success",
            "face": {
                "isFraud": "false",
                "liveness": "true",
                "match": "true",
                "percentMatch": 0.21930320654064417
            }
        }

          this.itemFaceId = result;
          this.isShowCardInfo = true;
          this.$store.dispatch(
            "verificationInfoStore/setItemFaceId",
            result
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgFaceId",
            this.imgFaceId
          );
          this.$router.push("/verification-info#id-card");
        return;
      }
      await this.callApiWithImage(base64);
    },
    async callApiWithImage(base64) {
      try {
        this.itemFaceId = null;
        this.imgFaceId = base64;
        if (!this.imgFaceId) return;

        if (this.defaultParam) {
          let params = this.stateAsObject(this.defaultParam);
          params = {
            ...params,
            image: this.imgFaceId.replace(/^data:image\/\w+;base64,/, ""),
          };
          if (this.orderDetail) {
            params.isdn = this.orderDetail.esimIsdn;
          }
          if (this.profile) {
            let tempPhone = this.profile.phone.replace(/\D/g, "");
            params.msisdn = tempPhone;
            params.partnerAccount = this.profile.id;
          }

          let provider = "";
          if (this.itemCCCD) {
            provider = this.itemCCCD.provider;
            params.provider = provider;
            params.transId = this.itemCCCD.transid;
            params.pathFront = this.itemCCCD.idCardInfo.pathImage;
          } 
          if (!provider) return; 
          this.$store.dispatch("loadingStore/showLoading", { status: true });
          
          await this.$store
              .dispatch("esimMetfoneStore/faceMatchV2EsimABA", params)
              .then((res) => {
                if (res) {
                  let result = res.data;
                  if (result && result.errorCode == 0) { 
                    this.$store.dispatch(
                      "verificationInfoStore/setItemFaceId",
                      result
                    );
                    this.$store.dispatch(
                      "verificationInfoStore/setImgFaceId",
                      this.imgFaceId
                    );
                    this.$router.push("/verification-info#id-card");
                  } else {
                    this.$notify({
                      code: result.errorCode,
                      message: result.errorDecription || result.message,
                      onClose: () => {
                        this.$refs.faceIdComponent?.enableWebcam();
                      },
                    });
                  }
                }
              });


          /*
          if (provider == "MASCOM") {
            await this.$store
              .dispatch("esimMetfoneStore/mascomFaceMatchV2EsimABA", params)
              .then((res) => {
                if (res) {
                  let result = res.data;
                  if (result && result.errorCode == 0) {
                    // this.itemFaceId = result;
                    // this.isShowCardInfo = true;
                    this.$store.dispatch(
                      "verificationInfoStore/setItemFaceId",
                      result
                    );
                    this.$store.dispatch(
                      "verificationInfoStore/setImgFaceId",
                      this.imgFaceId
                    );
                    this.$router.push("/verification-info#id-card");
                  } else {
                    this.$notify({
                      code: result.errorCode,
                      message: result.errorDecription,
                      onClose: () => {
                        this.$refs.faceIdComponent?.enableWebcam();
                      },
                    });
                  }
                }
              });
          }

          if (provider == "BLUETECH") {
            await this.$store
              .dispatch("esimMetfoneStore/faceMatchV2EsimABA", params)
              .then((res) => {
                if (res) {
                  let result = res.data;
                  if (result && result.errorCode == 0) {
                    // this.itemFaceId = result;
                    // this.isShowCardInfo = true;
                    this.$store.dispatch(
                      "verificationInfoStore/setItemFaceId",
                      result
                    );
                    this.$store.dispatch(
                      "verificationInfoStore/setImgFaceId",
                      this.imgFaceId
                    );

                    this.$router.push("/verification-info#id-card");
                  } else {
                    this.$notify({
                      code: result.errorCode,
                      message: result.errorDecription,
                      onClose: () => {
                        this.$refs.faceIdComponent?.enableWebcam();
                      },
                    });
                  }
                }
              });
          }
          */
        }
        this.$store.dispatch("loadingStore/showLoading", { status: false });
      } catch (error) {
        console.error("Error API:", error);
      }
    },
  },
};
</script>

<style>
.step-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 50px 0;
}

@media (max-width: 374px) {
  .step-container {
    padding: 30px 0 !important;
  }
}

.step-container .step {
  display: flex;
  justify-content: center;
  gap: 3px;
  min-width: fit-content;
}

.step-container .step p {
  margin: 0;
}

.step-container .step .step-number {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: rgba(217, 217, 217, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(16, 113, 110, 0.7);
  font-size: 12px;
}

.step-container .step .step-name {
  color: rgba(217, 217, 217, 0.7);
  font-size: 14px;
}

.step-container .step-line {
  width: 15px;
  height: 2px;
  background-color: rgba(217, 217, 217, 0.7);
}

.step-container .step-line.active {
  background-color: #fff;
}

.step-container .step.active .step-number {
  background-color: #fff;
  color: #10716d;
}

.step-container .step.active .step-name {
  color: #fff;
}

/* Custom image font */
.cs-image-font .van-image__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.capture-screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
}

/* Cusotm button */

.btn-capture-photo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  border: 3px solid #fff;
}

.bg-face-detect {
  background-color: #fff;
  width: 100%;
  height: 100vh;
}

/* Change color */
.cs-steps .step .step-number {
  background-color: rgba(196, 22, 39, 0.3);
  color: #c41627;
}

.cs-steps .step .step-name {
  color: rgba(196, 22, 39, 0.3);
}

.cs-steps .step-line {
  height: 1px !important;
  background-color: #000 !important;
}

.cs-steps .step.active .step-number {
  background-color: rgba(196, 22, 39, 0.3);
  color: #c41627;
}

.cs-steps .step.active .step-name {
  color: #c41627;
}
</style>